import React from 'react';

import { getProfileHref } from 'common/helpers/routerHelper';
import { useLocalization } from 'redux/localization/utils/hooks';

const NotLoggedIn = () => {
  const { t } = useLocalization();

  return (
    <div className="c7-user-nav__account">
      <a
        href={getProfileHref('/login')}
        className="c7-user-nav__account__login"
        data-testid="not-logged-in-login-link"
      >
        {t('customerAccount.login.log in')}
      </a>
    </div>
  );
};
export default NotLoggedIn;
